import { salon } from './content'

export type LocalIntroBlock = {
  title: string
  body: string
  link: { to: string; label: string } | { href: string; label: string }
}

/**
 * De drie blokken van de lokale introductie onderaan Contact — de zoekwaarde van de
 * oude homepage (salon, vegan skincare, huidadvies) in leesbare tekst.
 * Een functie, omdat telefoon en WhatsApp uit de actuele instellingen komen.
 */
export const localIntroBlocks = (): LocalIntroBlock[] => [
  {
    title: 'Gezichtsbehandelingen die je de dag erna nog ziet',
    body: 'Voor een huid die hormonaal uit balans is, of gewoon voor een uur rust. Elke behandeling combineert bindweefselmassage, ontspanning en huidverbetering, één cliënt tegelijk.',
    link: { to: '/behandelingen', label: 'Bekijk de behandelingen' },
  },
  {
    title: 'Vegan skincare die doet wat hij belooft',
    body: 'Dezelfde producten als in de salon. Van cleanser en toner tot vitamine C, retinal en SPF, te filteren op droge, vette, gevoelige of hormonale huid.',
    link: { to: '/webshop', label: 'Naar de webshop' },
  },
  {
    title: 'Huidadvies, ook bij rosacea of acne',
    body: 'Weet je niet wat bij je huid past? Stuur een appje. Ik kijk mee welke producten je nodig hebt en welke je kunt laten staan, ook als je (nog) niets koopt.',
    link: { href: salon.whatsapp, label: `WhatsApp ${salon.phone}` },
  },
]
